import { SiteHeader } from "@/components/site-header";
import { UnitsTable } from "./UnitsTable";

export default function UnitsPage() {
  return (
    <>
      <SiteHeader title="Unidades" />
      <div className="flex flex-1 flex-col px-4 py-6 lg:px-6">
        <UnitsTable />
      </div>
    </>
  );
}
